import GlobalStyles from '@mui/material/GlobalStyles';

export const AppGlobalStyles = () => {
  return (
    <GlobalStyles
      styles={{
        body: {
          margin: 0,
          padding: 0,
          backgroundColor: '#e8e8e8',
          fontFamily: "'Roboto', sans-serif",
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
        },
      }}
    />
  );
};
